import React from 'react';
import SignIn from '../components/auth/SignIn';

const SignInPage = () => <SignIn />;

export default SignInPage;
